module.exports = __webpack_public_path__ + "static/media/6.02c3ab74.jpg";